import { lazy } from "react";
import type { RouteObject } from "react-router-dom";

const HomePage = lazy(() => import("./app/onboarding/homePage"));
const FormPage = lazy(() => import("./app/onboarding/stepper"));
const EndPage = lazy(() => import("./app/onboarding/endPage"));
const ErrorPage = lazy(() => import("@root/error"));

export const onboardingRoutes: RouteObject[] = [
  {
    path: "/onboarding",
    element: <HomePage />,
    errorElement: <ErrorPage />,
  },
  {
    path: "/onboarding/form",
    element: <FormPage />,
    errorElement: <ErrorPage />,
  },
  {
    path: "/onboarding/end",
    element: <EndPage />,
    errorElement: <ErrorPage />,
  },
];
